import styles from './DndContextBuilder.module.css'
import React, {
  useContext,
  useRef,
  useCallback,
  useEffect,
  useState,
} from 'react'
import {
  DndContext,
  PointerSensor,
  KeyboardSensor,
  MouseSensor,
  TouchSensor,
  useSensor,
  useSensors,
  DragOverlay,
} from '@dnd-kit/core'
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable'
import { observer } from 'mobx-react-lite'
import SidebarFields from '../SidebarFields/SidebarFields'
import Canvas from '../Canvas/Canvas'
import SidebarField from '../SidebarFields/components/Field/SidebarField'
import RenderedField from '../AvailableFields/RenderedField'
import { BuilderContext } from '../store/store.Builder'
import { arrayMove } from '@dnd-kit/sortable'
import Announcements from '../../Announcements'
import { toJS } from 'mobx'
import { updateFieldsAPI } from '../../../../services/api'
import { Try } from '@mui/icons-material'
const DndContextBuilder = observer(() => {
  const renderCountRef = useRef(0)
  renderCountRef.current += 1

  useEffect(() => {
    console.log(`DndContext render count: ${renderCountRef.current}`)
  })

  const builderContext = useContext(BuilderContext)

  const mouseSensor = useSensor(MouseSensor, {
    // Require the mouse to move by 10 pixels before activating
    activationConstraint: {
      distance: 5,
    },
  })

  const touchSensor = useSensor(TouchSensor, {
    // Press delay of 250ms, with tolerance of 5px of movement
    activationConstraint: {
      delay: 250,
      tolerance: 5,
    },
  })

  const sensors = useSensors(mouseSensor, touchSensor)

  const getData = useCallback((prop) => {
    return prop?.data?.current ?? {}
  }, [])

  const createSpacer = useCallback(({ id }) => {
    return {
      id,
      type: 'spacer',
      title: 'spacer',
    }
  }, [])

  const spacerInsertedRef = useRef()
  const currentDragFieldRef = useRef()
  const originRef = useRef(null)
  const startIndexRef = useRef(null)

  const cleanUp = () => {
    builderContext.setActiveSidebarField(null)
    builderContext.setActiveField(null)
    currentDragFieldRef.current = null
    spacerInsertedRef.current = false
  }

  const handleDragStart = useCallback(
    (e) => {
      console.log('handleDragStart')
      const { active } = e
      const activeData = getData(active)
      builderContext.setIsBarButtonVisible(false)
      startIndexRef.current = activeData.index

      if (activeData.fromSidebar) {
        originRef.current = 'sidebar'
        const { field } = activeData
        const { type } = field
        builderContext.setActiveSidebarField(field)

        const baseDragField = {
          id: active.id,
          type,
          name: `${type}${builderContext.fields.length + 1}`,
          parent: null,
          ...field, // copie toutes les propriétés de 'field'
        }
        try {
          if (builderContext.field_default_design) {
            if (baseDragField.design) {
              baseDragField.design = {
                ...builderContext.field_default_design,
                ...(baseDragField.specific_design || {}),
              }
            }
          }
          if (builderContext.label_default_design) {
            if (baseDragField.label_design) {
              baseDragField.label_design = {
                ...builderContext.label_default_design,
                ...(baseDragField.specific_label_design || {}),
              }
            }
          }
          if (builderContext.description_default_design) {
            if (baseDragField.description_design) {
              baseDragField.description_design = {
                ...builderContext.description_default_design,
                ...(baseDragField.specific_description_design || {}),
              }
            }
          }

          if (builderContext.input_default_design) {
            if (baseDragField.input_design) {
              baseDragField.input_design = {
                ...builderContext.input_default_design,
                ...(baseDragField.specific_input_design || {}),
              }
              // console.log('baseDragField updated', toJS(baseDragField))
            }
          }

          console.log('KSKSKDSKDKSKDSKDKSKDKSDKSKD', toJS(baseDragField))
          currentDragFieldRef.current = baseDragField
          console.log(
            'KSKSKDSKDKSKDSKDKSKDKSDKSKD',
            toJS(currentDragFieldRef.current)
          )
          return
        } catch (error) {
          console.error(
            'Une erreur est survenue lors du drag and drop : ',
            error
          )
        }
      } else {
        originRef.current = 'canvas'
      }

      const { field, index } = activeData
      builderContext.setActiveField(field)
      currentDragFieldRef.current = field
      builderContext.replaceField(createSpacer({ id: active.id }), index)
    },
    [builderContext]
  )

  const handleDragOver = useCallback(
    (e) => {
      console.log('handleDragOver')
      const { active, over } = e

      const activeData = getData(active)

      if (activeData.fromSidebar) {
        const overData = getData(over)

        if (!spacerInsertedRef.current) {
          const spacer = createSpacer({
            id: active.id + '-spacer',
          })

          // insert the spacer only when over the canvas
          if (over) {
            builderContext.insertField(
              spacer,
              overData.index > -1
                ? overData.index
                : builderContext.data.fields.length
            )
            spacerInsertedRef.current = true
          }
        } else if (!over) {
          builderContext.removeField(active.id + '-spacer')
          spacerInsertedRef.current = false
        } else {
          builderContext.moveField(
            builderContext.data.fields.findIndex(
              (f) => f.id === active.id + '-spacer'
            ),
            overData.index
          )
        }
      }
    },
    [builderContext]
  )

  const handleDragEnd = useCallback(
    (e) => {
      console.log('handleDragEnd')
      const { over } = e
      console.log('over', over)
      console.log('e', e)

      let nextField = currentDragFieldRef.current

      if (nextField) {
        const overData = over ? getData(over) : null

        // replace spacer with the nextField
        const spacerIndex = builderContext.data.fields.findIndex(
          (f) => f.type === 'spacer'
        )
        if (spacerIndex > -1) {
          builderContext.replaceField(nextField, spacerIndex)

          if (overData) {
            // move nextField to the right position
            const nextFieldIndex = builderContext.data.fields.findIndex(
              (f) => f.id === nextField.id
            )

            try {
              if (e.active.data.current.fromSidebar) {
                console.log(
                  'Je vais modifier quelque chose alors je sauvegarde letat actuel avant'
                )
                // DANS CE CAS J4AI BESOIN ABSOLUMENT DE SUPPRIMER LE FIELD PROVENANT DE LA SIDEBARFIELD
                const fieldsCopy = builderContext.data.fields.filter(
                  (field) => field.id !== e.active.id
                )

                console.log('builderContext.data.fields', toJS(fieldsCopy))

                builderContext.prepareAndAddToHistory(
                  { ...builderContext.styleForm }, // copie de styleForm
                  [...fieldsCopy] // copie de fieldsCopy
                )
              } else {
                if (overData?.index !== nextFieldIndex) {
                  console.log(
                    'Je vais modifier quelque chose alors je sauvegarde letat actuel avant'
                  )
                  builderContext.prepareAndAddToHistory(
                    { ...builderContext.styleForm }, // copie de styleForm
                    [...builderContext.data.fields] // copie de data.fields
                  )
                }
              }
            } catch {
              console.log('erreur dans le DND Context / HandleDragEnd ')
            }

            console.log('overData.index', overData.index)
            console.log('nextFieldIndex', nextFieldIndex)
            builderContext.moveField(nextFieldIndex, overData.index || 0)
          }
        } else if (!overData) {
          // Restore the field to its original position if it was dragged outside of the canvas
          builderContext.moveField(nextField.id, startIndexRef.current)
        }
        builderContext.setSidebarFieldsRegenKey(Date.now())
        builderContext.removeAllSpacers() // remove all spacers
        builderContext.setSelectedField({ ...nextField }, 'field')
        builderContext.updateFields()
        builderContext.setIsBarButtonVisible(true)
      }

      cleanUp()
    },
    [cleanUp, builderContext]
  )

  return (
    <DndContext
      sensors={sensors}
      onDragStart={handleDragStart}
      onDragOver={handleDragOver}
      onDragEnd={handleDragEnd}
      autoScroll
    >
      {/* <Announcements /> */}
      <SidebarFields />
      <SortableContext
        strategy={verticalListSortingStrategy}
        items={builderContext.fields.map((f) => f.id)}
      >
        <Canvas />
      </SortableContext>
      <DragOverlay dropAnimation={false}>
        {builderContext.activeSidebarField ? (
          <SidebarField overlay field={builderContext.activeSidebarField} />
        ) : null}
        {builderContext.activeField ? (
          <RenderedField overlay field={builderContext.activeField} />
        ) : null}
      </DragOverlay>
    </DndContext>
  )
})

export default DndContextBuilder
